import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /auth/* children (action, callback) render through here.
// The sign-in page itself lives at ./auth/index.tsx ("/auth/").
export const Route = createFileRoute("/auth")({
  component: () => <Outlet />,
});
